import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap'
import auth from '../../api/auth/hooks'
import { selectIsImpersonated } from '../../store/auth'
import Loader from './Loader'

const ProfileDropdown = () => {
    const history = useHistory()
    const { t } = useTranslation()

    const [userName, setUserName] = useState<string | null>(null)
    const [isProfileDropdown, setIsProfileDropdown] = useState(false)

    const isImpersonated = useSelector(selectIsImpersonated)

    const { data: currentAgent } = auth.CurrentAgent.useQuery({
        select: (data) => ({
            firstName: data.firstName,
            lastName: data.lastName,
            photo: data.photo,
            roles: data.roles,
        }),
    })
    const { mutate: logout } = auth.Logout.useMutation()

    useEffect(() => {
        if (currentAgent && currentAgent.firstName && currentAgent.lastName) {
            setUserName(`${currentAgent.firstName} ${currentAgent.lastName}`)
        }
    }, [currentAgent])

    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown)
    }

    const handleLogOut = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault()
        logout()
    }

    const userThumbnail = (
        <img className="rounded-circle header-profile-user" src={currentAgent?.photo ?? undefined} alt="User thumbnail" />
    )

    const userThumbnailPlaceholder = (
        <div className="flex-shrink-0 avatar-xs acitivity-avatar">
            <div className="avatar-title bg-light text-primary rounded-circle">
                {' '}
                {currentAgent && currentAgent.firstName && currentAgent.lastName
                    ? `${currentAgent.firstName?.charAt(0)?.toUpperCase()}${currentAgent.lastName?.charAt(0)?.toUpperCase()}`
                    : 'A'}{' '}
            </div>
        </div>
    )

    const impersonationBadge = <i className="mdi mdi-incognito-circle fs-1 text-warning"></i>

    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
                <DropdownToggle tag="button" type="button" className="btn">
                    <span className="d-flex align-items-center">
                        {isImpersonated ? impersonationBadge : currentAgent?.photo ? userThumbnail : userThumbnailPlaceholder}
                        <span className="text-start ms-xl-2">
                            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{userName ? userName : <Loader />}</span>
                        </span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    {currentAgent?.roles?.includes('ROLE_ADMIN') &&
                        (history?.location?.pathname?.split('/')[1] === 'admin' ? (
                            <DropdownItem to={'/'} tag={Link}>
                                <i className="mdi mdi-keyboard-backspace text-muted fs-16 align-middle me-1"></i>{' '}
                                <span className="align-middle">{t('app.user.backToSoftwere')}</span>
                            </DropdownItem>
                        ) : (
                            <DropdownItem to={'/admin/agency'} tag={Link}>
                                <i className="mdi mdi-head-cog text-muted fs-16 align-middle me-1"></i>{' '}
                                <span className="align-middle">{t('app.user.administration')}</span>
                            </DropdownItem>
                        ))}
                    <DropdownItem to={''} tag={Link} onClick={(e) => handleLogOut(e)}>
                        <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>{' '}
                        <span className="align-middle" data-key="t-logout">
                            {t('app.user.logout')}
                        </span>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    )
}

export default ProfileDropdown
